export default "__VITE_ASSET__BMa2EacZ__"